import React from 'react';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

import {
  deletePaginationParams,
  BEFORE_PARAM,
  AFTER_PARAM,
} from '@occc-app/hooks/usePaginationParams';
import { useQueryParam } from '@occc-app/hooks/useQueryParam';

import { UserRoleFilterFormValues } from './user-role-filter.types';

const DEFAULT_USER_ROLE_FILTER_PARAM = 'userRoleFilter';

type UseUserRoleFilterOptions = {
  filterParamName?: string;
  beforeParamName?: string;
  afterParamName?: string;
};

export const useUserRoleFilter = ({
  filterParamName = DEFAULT_USER_ROLE_FILTER_PARAM,
  beforeParamName = BEFORE_PARAM,
  afterParamName = AFTER_PARAM,
}: UseUserRoleFilterOptions = {}) => {
  const userFilterPopupState = usePopupState({ variant: 'popover', popupId: 'filters' });
  const userFilterPopoverProps = React.useMemo(() => {
    return {
      ...bindPopover({
        ...userFilterPopupState,
      }),
    };
  }, [userFilterPopupState]);

  const [userRoleFilter, setUserRoleFilter] = useQueryParam<UserRoleFilterFormValues>(
    (searchParams) => {
      const role = searchParams.get(filterParamName) || 'all';
      return role as UserRoleFilterFormValues;
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(filterParamName, value);
      } else {
        searchParams.delete(filterParamName);
      }

      deletePaginationParams(searchParams, beforeParamName, afterParamName);
    },
  );

  return { userRoleFilter, userFilterPopoverProps, userFilterPopupState, setUserRoleFilter };
};
